export default "__VITE_ASSET__BgV7TPyQ__"